import Title from './Title';
import Form from './Form';
import StaticCol from './StaticCol';

export { Title, Form, StaticCol };
